import $ from 'jquery';
import SliderTwitter from './Slider.Twitter';

const GET_TWEETS_URL = '/dd_twitter_feed/get_tweets';

class TwitterFeed {
  constructor(element) {
    this.$element = $(element);
    this.success = this.success.bind(this);
    this.complete = this.complete.bind(this);
    this.request = this.sendRequest();
  }

  sendRequest() {
    return $.ajax(GET_TWEETS_URL, {
      cache: true,
      dataType: 'html',
      success: this.success,
      complete: this.complete,
    });
  }

  success(data) {
    const $tweets = this.$element.find('.tweets');
    $tweets.html(data);
    $tweets.each((i, element) => {
      if (!element.sliderTwitter) {
        element.sliderTwitter = new SliderTwitter(element);
      }
    });
  }

  complete() {
    this.$element.addClass('ready');
  }
}

export default TwitterFeed;
